import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountryStore } from '@zopup/zop-apis';

@Component({
    selector: 'zop-test-address',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, FormlyModule],
    templateUrl: './test-address.component.html',
    styleUrl: './test-address.component.scss'
})
export class TestAddressComponent extends FieldType implements OnInit {
    ngOnInit(): void {
        console.log('TestAddressComponent.ngOnInit');
    }
    readonly countryStore = inject(CountryStore);

    // async ngOnInit(): Promise<void> {
    //     //  await this.countryStore.getList();
    //     // this.initializeComponentProps();
    //     // await this.loadAddressFields();
    //     // fields$.subscribe(() => {
    //     //     this.emitFieldsToParent();
    //     // });
    // }

    fields: FormlyFieldConfig[] = [
        {
            key: 'street',
            type: 'input',
            templateOptions: {
                label: 'Street',
                required: true,
            },
        },
        {
            key: 'city',
            type: 'input',
            templateOptions: {
                label: 'City',
                required: true,
            },
        },

        // {
        //     key: 'country',
        //     type: 'autocomplete',
        //     props: {
        //         label: 'Select with custom name/value/group',
        //         options: [
        //             {
        //                 label: 'Iron Man',
        //                 id: 'iron_man',
        //                 gender: 'Male',
        //             },
        //             {
        //                 label: 'Captain America',
        //                 id: 'captain_america',
        //                 gender: 'Male',
        //             },
        //             {
        //                 label: 'Black Widow',
        //                 id: 'black_widow',
        //                 gender: 'Female',
        //             },
        //             { label: 'Hulk', id: 'hulk', gender: 'Male' },
        //             {
        //                 label: 'Captain Marvel',
        //                 id: 'captain_marvel',
        //                 gender: 'Female',
        //             },
        //         ],
        //         valueProp: 'id',
        //         labelProp: 'label',
        //     },
        // },

        {
            key: 'postalCode',
            type: 'input',
            templateOptions: {
                label: 'Postal Code',
                required: true,
            },
        },
    ];
}
